import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AreaViewComponent } from '@fi-app/area/area-view/area-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { AreaService } from '@fi-app/area/area.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAreaAddStateResolve_countries } from '@fi-app/area/states/area-add-state';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';

export const FiAreaViewState: Ng2StateDeclaration = {
    name: FiStateNames.Area.View,
    url: '/:Id',
    views: {
        '@': {
            component: AreaViewComponent,
        },
    },
    resolve: {
        area: [FiStateService, AreaService, Transition, FiAreaViewStateResolve_area],
        countries: [FiCountryHelperService, FiAreaAddStateResolve_countries],
        pageTitle: [PageTitleService, 'area', FiAreaViewStateResolve_pageTitle],
    },
};

export function FiAreaViewStateResolve_area(fiStateService: FiStateService, areaService: AreaService, tr: Transition) {
    return areaService.GetArea(fiStateService.getParams(tr).Id);
}

export function FiAreaViewStateResolve_pageTitle(ccmPageTitle: PageTitleService, area) {
    return ccmPageTitle.setTitleByItem(area);
}
